import { nullable, number } from "../../../../api/analytics/utils/Cubestruct";

export const BigQuerySpendSummaryStruct = {
  onDemandCost: nullable(number()),
};
